import { getMessages } from '../../../../../../../store/constants';

export const CLASS_CARD_PRIORITY = 'card-priority';

export const CARD_SELECT_PRIORITY = getMessages().getText('card_form_select_priority');
